export enum ReservationErrorModalEnum {
  DateExpired
}
